import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Shopping list empty state. A cheerful (empty) shopping bag. */
export function ShoppingBag(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <ellipse cx="80" cy="142" rx="46" ry="6" style={{ fill: sc('border.default') }} />
      <path
        d="M58 58V48a22 22 0 0 1 44 0v10"
        style={{ fill: 'none', stroke: c('neutral.700'), strokeWidth: 6, strokeLinecap: 'round' }}
      />
      <path d="M36 56h88l-6 80H42z" style={{ fill: c('blue.500') }} />
      <path d="M36 56h88l-2 18H38z" style={{ fill: c('blue.600') }} />
      <circle cx="58" cy="66" r="4" style={{ fill: c('neutral.0') }} />
      <circle cx="102" cy="66" r="4" style={{ fill: c('neutral.0') }} />
      <path
        d="M68 102c4 6 20 6 24 0"
        style={{ fill: 'none', stroke: c('neutral.0'), strokeWidth: 5, strokeLinecap: 'round' }}
      />
      <circle cx="66" cy="92" r="3.5" style={{ fill: c('neutral.0') }} />
      <circle cx="94" cy="92" r="3.5" style={{ fill: c('neutral.0') }} />
      <circle cx="132" cy="36" r="4" style={{ fill: c('gold.400') }} />
      <rect
        x="20"
        y="40"
        width="8"
        height="8"
        rx="2"
        transform="rotate(20 24 44)"
        style={{ fill: c('berry.300') }}
      />
    </IllustrationFrame>
  );
}
